// Portado de src/components/tratamento/Pilares.astro (site Astro).
import type { ReactNode } from "react";

export interface PilaresItem {
  icone: string;
  titulo: string;
  texto: ReactNode;
  link?: { href: string; rotulo: string };
}

export interface PilaresProps {
  sobretitulo: string;
  titulo: string;
  chamada?: ReactNode;
  itens: PilaresItem[];
}

export function Pilares({ sobretitulo, titulo, chamada, itens }: PilaresProps) {
  return (
    <section className="pilares-secao">
      <div className="container">
        <div className="secao-titulo">
          <p className="sobretitulo">{sobretitulo}</p>
          <h2>{titulo}</h2>
          {chamada && <p className="secao-chamada">{chamada}</p>}
        </div>
        <ul className="pilares">
          {itens.map((c, i) => (
            <li className="pilar" key={i}>
              <span className="pilar-icone">
                <img src={c.icone} width={24} height={24} alt="" loading="lazy" />
              </span>
              <div className="pilar-texto">
                <h3>{c.titulo}</h3>
                <p>{c.texto}</p>
                {c.link ? <a className="pilar-link" href={c.link.href}>{c.link.rotulo}</a> : null}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
